2<template>
  <v-app :style="'background-color:' + _backgroudcolor">
    <v-content>
      <v-layout mt-2 row wrap align-center justify-center>
        <v-flex sm4 md7 lg7 pl-5>
          <v-card class="mx-auto elevation-0" outlined color="transparent">
            <v-card-title>
              <v-avatar :color="_pageDetailcolor">
                <v-icon dark>mdi-movie-edit</v-icon>
              </v-avatar>
              <h4
                class="ml-2"
                :style="'font-size: 18px; color:' + _pageDetailcolor"
              >
                {{ $t("settingemail.condition.title_edit") }}
              </h4>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex sm8 md5 lg5 text-right pr-10>
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
      </v-layout>

      <v-container grid-list-lg fluid mt-n7>
        <v-layout row wrap>
          <!-- ซ้าย -->
          <v-flex lg9 sm12 xs12 pa-4 pt-5 pb-2>
            <v-card class="mx-auto pa-8 elevation-0" outlined>
              <v-layout row wrap justify-left align-center>
                <v-flex lg2 sm2 xs12 class="pa-1">
                  <b>{{ $t("settingemail.condition.condition_doc_type") }} :</b>
                </v-flex>
                <v-flex lg3 sm3 xs12 class="pa-1">
                  <v-select
                    v-model="item_select"
                    :items="$t('typeCode.notAll')"
                    item-text="text"
                    item-value="value"
                    menu-props="auto"
                    :label="$t('settingemail.condition.condition_select_doc')"
                    hide-details
                    outlined
                    dense
                  ></v-select>
                </v-flex>
                <v-flex lg1 sm1 xs12></v-flex>
                <v-flex lg2 sm2 xs12 class="pa-1">
                  <b>Source System :</b>
                </v-flex>
                <v-flex lg4 sm3 xs12 class="pa-1">
                  <v-text-field
                    v-model="sourceSystem"
                    label="Source System"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-left align-center>
                <v-flex lg2 sm2 xs12 class="pa-1">
                  <b>Display Name :</b>
                </v-flex>
                <v-flex lg10 sm9 xs12 class="pa-1">
                  <v-text-field
                    v-model="display_name"
                    label="Display Name"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-left align-center>
                <v-flex lg2 sm2 xs12 class="pa-1">
                  <b>Subject Email :</b>
                </v-flex>
                <v-flex lg10 sm9 xs12 class="pa-1">
                  <v-text-field
                    v-model="subjectEmail"
                    label="Subject Email"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-left align-center>
                <v-flex lg3 sm3 xs12 class="pa-1">
                  <b
                    >{{
                      $t("settingemail.condition.condition_templateformat")
                    }}
                    :</b
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center align-center>
                <v-flex lg11 sm10 xs11 class="pa-1">
                  <v-card-text style="margin-left: 5%; margin-top: -2%">
                    <v-tabs :color="_pageDetailcolor" v-model="tab">
                      <v-tab> Editor </v-tab>
                      <v-tab> Html code </v-tab>
                      <!-- tab editor -->
                      <v-tab-item>
                        <vue-editor
                          v-model="content"
                          hide-details
                          :editorToolbar="defaultToolbar"
                        />
                      </v-tab-item>
                      <!-- tab html code -->
                      <v-tab-item class="pb-5">
                        <v-textarea
                          dark
                          outlined
                          auto-grow
                          no-resize
                          background-color="#2E394F"
                          row-height="50"
                          v-model="htmlCode"
                          style="color: white"
                        ></v-textarea>
                      </v-tab-item>
                    </v-tabs>
                  </v-card-text>
                  <br />
                  <v-card-actions>
                    <v-layout row wrap justify-center align-center>
                      <v-flex lg3 md3 sm4 xs12>
                        <v-btn
                          to="/portal/setting_email_template_index"
                          outlined
                          color="#f05c5a"
                          block
                          ><v-icon left> mdi-close-circle-outline </v-icon
                          >{{ $t("settingemail.condition.btn_cancle") }}</v-btn
                        >
                      </v-flex>
                      <v-flex lg3 md3 sm4 xs12>
                        <v-btn
                          @click="fn_testForm"
                          dark
                          block
                          color="#609cd4"
                          >{{
                            $t("settingemail.condition.btn_test_email")
                          }}</v-btn
                        >
                      </v-flex>
                      <v-flex lg3 md3 sm4 xs12>
                        <v-btn
                          @click="fn_save"
                          :color="_pageDetailcolor"
                          dark
                          block
                          >{{ $t("settingemail.condition.btn_save") }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <!-- ขวา -->
          <DialogSelector @fn_selector="fn_selector"> </DialogSelector>
        </v-layout>
        <DialogTestSendmail
          :show="showTestsendMail"
          :html="encodeHtml"
          :subjectEmail="subjectEmail"
          :displayName="display_name"
          @closeDialog="showTestsendMail = false"
        ></DialogTestSendmail>

        <!-- check credit type -->
        <DialogCreditTypeCheck />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import authorization from "@/authorization/authorization.js";
import DialogTestSystem from "@/components/portal/dialog/dialog-test-system";
import DialogSelector from "@/components/portal/dialog/email/portal-dialog-selector";
import DialogTestSendmail from "@/components/portal/dialog/email/portal-dialog-testSendmail";
import DialogCreditTypeCheck from "@/components/portal/dialog/package/checkCreditType.vue";
import swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import { mapGetters, mapState } from "vuex";
export default {
  name: "setting_email",
  components: {
    VueEditor,
    DialogTestSendmail,
    DialogSelector,
    DialogTestSystem,
    DialogCreditTypeCheck,
  },
  data: function () {
    return {
      content: "",
      htmlCode: "",
      tab: 0,
      showTestsendMail: false,
      encodeHtml: "",
      usercode: "",
      // temlateName: '',
      templateId: "",
      subjectEmail: "",
      sourceSystem: "",
      item_select: "",
      display_name: "",
      itemsTextSpecial: [
        { value: "", text: "เลือกข้อความพิเศษ" },
        { value: "{{document_id}}", text: "เลขที่เอกสาร" },
        { value: "{{buyer_id}}", text: "รหัสผู้ซื้อ" },
        { value: "{{buyer_tax_id}}", text: "เลขประจำตัวผู้เสียภาษี (ผู้ซื้อ)" },
        { value: "{{buyer_name}}", text: "ชื่อผู้ซื้อ" },
        { value: "{{bussiness_name}}", text: "ชื่อบริษัท" },
        { value: "{{document_name}}", text: "ประเภทเอกสาร (ชื่อ)" },
        {
          value: "{{document_date}}",
          text: "วันที่ (อ้างอิงจากวันที่ในเอกสาร)",
        },
      ],
      text_special: "",
      defaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
        // ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        // [{ indent: "-1" }, { indent: "+1" }],
        // ["link", "image", "video"],
        // ["clean"],
      ],
      htmlHead: `<html><head>
                 <style>.space {white-space: pre;}   
                        p {margin: 0px;}
                        .ql-align-left {
                          text-align: left;
                        }
                        .ql-align-center {
                          text-align: center;
                        }
                        .ql-align-right {
                          text-align: right;
                        }</style>
                </head><body><div class='space'>`,
      htmlTail: "</div></body></html>",
    };
  },
  computed: {
    ...mapGetters(["getter_dataBusiness_profile"]),
    ...mapState(["backgroudcolor", "pageDetailcolor"]),
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _SellerBranchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
    _sourceSystem: {
      get() {
        if (this.sourceSystem === "") {
          return null;
        } else {
          return this.sourceSystem;
        }
      },
    },
    _checkTab: {
      get() {
        if (this.tab == 1) {
          return true;
        } else {
          return false;
        }
      },
    },
  },
  async mounted() {
    await this.fn_loadData();
  },
  methods: {
    fn_loadData: async function () {
      var payload = {
        seller_id: localStorage.etax_sellerid,
        taxid: this._taxId,
        branchid: this._SellerBranchId,
        id: this.$route.query.id,
        subject_email: this.subjectEmail,
        usercode: localStorage.etax_username,
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_SERVICE_SETTING_TEMPLATE_EMAIL_API + "/getconfig",
          { data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            this.item_select = res.data.message[0].document_type_code;
            this.templateId = res.data.message[0].id;
            if (res.data.message[0].subject_email === null) {
              this.subjectEmail = "";
            } else {
              this.subjectEmail = res.data.message[0].subject_email;
            }

            this.sourceSystem = res.data.message[0].source_system;
            this.usercode = res.data.message[0].usercode
            this.display_name = res.data.message[0].display_name;
            if (res.data.message[0].html_custom == true) {
              this.htmlCode = res.data.message[0].html_send;
              this.tab = 1;
            } else {
              this.content = res.data.message[0].html_edit;
              this.tab = 0;
            }
          } else {
            swal.fire(this.$t("alert.fail"), res.data.errorMessage, "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              String(error.response.data.message),
              "error"
            );
            // do something
          } else if (error.request) {
            swal.fire(this.$t("alert.fail"), error.request, "error");
            // do something else
          } else if (error.message) {
            swal.fire(this.$t("alert.fail"), error.message, "error");
            // do something other than the other two
          } else {
            swal.fire(this.$t("alert.fail"), String(error), "error");
          }
        });
    },
    fn_testForm() {
      if (this.tab == 0) {
        this.encodeHtml = this.htmlHead + this.content + this.htmlTail;
      } else {
        this.encodeHtml = this.htmlCode;
      }
      this.showTestsendMail = true;
    },

    fn_selector(val) {
      if (val.content == "body") {
        if (this.tab == 0) {
          this.content = this.content + val.key;
        } else {
          this.htmlCode = this.htmlCode + val.key;
        }
      } else {
        this.subjectEmail = this.subjectEmail + val.key;
      }
    },

    async fn_save() {
      if (this.tab == 0) {
        var payloadHtml = this.htmlHead + this.content + this.htmlTail;
        var html_edit = this.content;
      } else {
        var payloadHtml = this.htmlCode;
        var html_edit = "";
      }
      var payload = {
        seller_id: localStorage.etax_sellerid,
        id: this.$route.query.id,
        taxid: this._taxId,
        document_type_code: this.item_select,
        branchid: this._SellerBranchId,
        html_edit: html_edit,
        html_send: payloadHtml,
        usercode: this.usercode,
        subject_email: this.subjectEmail,
        source_system: this._sourceSystem,
        html_custom: this._checkTab,
        display_name: this.display_name,
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this._taxId);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .put(
          process.env.VUE_APP_SERVICE_SETTING_TEMPLATE_EMAIL_API,
          { data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            swal.fire(
              this.$t("alert.success"),
              this.$t("create_bill_mail.swal.save_temp_success"),
              "success"
            );
            this.$router.push("/portal/setting_email_template_index");
          } else {
            swal.fire(this.$t("alert.fail"), res.data.errorMessage, "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              String(error.response.data.message),
              "error"
            );
            // do something
          } else if (error.request) {
            swal.fire(this.$t("alert.fail"), error.request, "error");
            // do something else
          } else if (error.message) {
            swal.fire(this.$t("alert.fail"), error.message, "error");
            // do something other than the other two
          } else {
            swal.fire(this.$t("alert.fail"), String(error), "error");
          }
        });
    },
  },
};
</script>

<style scoped>
.special-text {
  /* background-color: rgb(9, 53, 73); */
  border: 2px solid rgb(9, 53, 73);
  width: 250px;
  height: 100px;
  display: flex;
  color: black;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
</style>
